export default __webpack_public_path__ + "static/media/logo.df6634c4.svg";